import { COMMUNITY_AVATAR_BASE_URL } from "../../Constants";

export const generateCommunityAvatarUrl = (name) => {
  const encodedName = encodeURIComponent(name || "");
  return COMMUNITY_AVATAR_BASE_URL.replace("{{NAME}}", encodedName);
};

export const isAvatarFromUiService = (url, baseUrl) => {
  try {
    const incomingDomain = new URL(url).hostname;
    const baseDomain = new URL(baseUrl).hostname;
    return incomingDomain === baseDomain;
  } catch (error) {
    console.warn("Invalid URL in isAvatarFromUiService:", error);
    return false;
  }
};
